import React, { useCallback, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import TitleTypography from '../../../MUI/TitleTypography';
import {
  bindTravelSelectedPlanCoverages,
  getTravelAvailableLimits,
} from '../../../../helpers/travel/travelCalcHelpers';
import { TRAVEL_PLANS, TRAVEL_PLANS_LABEL } from '../../../../constants/travelCalcConstants';
import ProgramSelection from './ProgramSelection';

import useStyles from './makeStyles';

const TravelPrograms = ({
  plans,
  setSelectedPlan,
  region,
  selectedPlan,
  selectedLimit,
  setSelectedLimit,
  type,
  isFetchingPrice,
  amount,
  formProps,
  onCoverageChange,
}) => {
  const { t } = useTranslation();
  const { setError, getValues, clearError } = formProps;
  const classes = useStyles();

  const availableLimits = useMemo(() => getTravelAvailableLimits(plans, selectedPlan, region),
    [plans, region, selectedPlan]);

  const handleChangePlan = useCallback(
    (newPlan) => {
      setSelectedPlan(newPlan);
      // onCoverageChange({});
      if (newPlan !== TRAVEL_PLANS_LABEL.GEORGIA && getValues().days < 3) {
        setError('days', 'invalid', 'validationErrors.minDays');
      }
      if (newPlan !== TRAVEL_PLANS_LABEL.GEORGIA) {
        onCoverageChange(bindTravelSelectedPlanCoverages(
          TRAVEL_PLANS_LABEL.ELITE,
        ));
      }
      if (newPlan === TRAVEL_PLANS_LABEL.GEORGIA) {
        onCoverageChange(bindTravelSelectedPlanCoverages(
          TRAVEL_PLANS_LABEL.GEORGIA,
        ));
        clearError('days');
      }
    },
    [setSelectedPlan, setError, getValues, clearError, onCoverageChange],
  );

  return (
    !isEmpty(plans) && (
      <Grid container>
        <Grid item xs={12} style={{ marginBottom: '1rem', marginTop: '1rem' }}>
          <TitleTypography className={classes.sectionTitle}>{t(`${type}.plans`)}</TitleTypography>
        </Grid>
        <Grid item xs={12}>
          <ProgramSelection
            plans={plans}
            selectedPlan={selectedPlan || TRAVEL_PLANS.ELITE.label}
            handleChangePlan={handleChangePlan}
            setSelectedLimit={setSelectedLimit}
            availableLimits={availableLimits}
            selectedLimit={selectedLimit}
            type={type}
            isFetchingPrice={isFetchingPrice}
            amount={amount}
          />
        </Grid>
      </Grid>
    )
  );
};

TravelPrograms.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setSelectedPlan: PropTypes.func.isRequired,
  region: PropTypes.string,
  selectedPlan: PropTypes.string.isRequired,
  selectedLimit: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
  setSelectedLimit: PropTypes.func.isRequired,
  onCoverageChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  isFetchingPrice: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  formProps: PropTypes.shape({
    setError: PropTypes.func,
    clearError: PropTypes.func,
    getValues: PropTypes.func,
  }).isRequired,
};

TravelPrograms.defaultProps = {
  region: null,
};

export default TravelPrograms;
